import React, { useEffect, useState, useRef } from "react";
import { Card } from "primereact/card";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { DataTable } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown";
import { Column } from "primereact/column";
import { Dialog } from "primereact/dialog";

import { UniversiteService } from "../service/UniversiteService";
import { EtablissementService } from "../service/EtablissementService";
import { DepartementService } from "../service/DepartementService";
import { ParcoursService } from "../service/ParcoursService";
import { NiveauService } from "../service/NiveauService";
import { AnneeAcademiqueService } from "../service/AnneeAcademiqueService";
import { RetraitService } from "../service/RetraitService";

function ListeRetrait() {
  const [formData, setFormData] = useState({
      idUniversite: null,
      idEtablissement: null,
      idDepartement: null,
      idParcours: null,
      idNiveau: null,
      idAnneeAcademique: null,
      libelleDiplome: "",
    });
  
    const [retraits, setRetraits] = useState([]);
    const [retrait, setRetrait] = useState(null);
    const [status, setStatus] = useState(null);
    const [loading, setLoading] = useState(false);
    const [loadingData, setLoadingData] = useState(true);
  
    const [universites, setUniversites] = useState([]);
    const [etablissements, setEtablissements] = useState([]);
    const [departements, setDepartements] = useState([]);
    const [parcours, setParcours] = useState([]);
    const [niveaux, setNiveaux] = useState([]);
    const [annees, setAnnees] = useState([]);
  
    const retraitService = new RetraitService()
    const univService = new UniversiteService()
    const etabService = new EtablissementService()
    const deptService = new DepartementService()
    const parsService = new ParcoursService()
    const nivService = new NiveauService()
    const annService = new AnneeAcademiqueService()

    let codeIesr = localStorage.getItem("codeIesr")
    let role_admin = localStorage.getItem("admin_secure")
    let role_univ = localStorage.getItem("univ_secure")
    role_admin = JSON.parse(role_admin)
    role_univ = JSON.parse(role_univ)
    codeIesr = JSON.parse(codeIesr)

    useEffect(() => {
        if(role_admin){
        const fetchInitialData = async () => {
          try {
            const [univData, anneeData] = await Promise.all([
              univService.getUniversites(),
              annService.getAnneesAcademiques(),
            ]);
            setUniversites(univData);
            setAnnees(anneeData);
          } catch (err) {
            setStatus({ type: "error", message: "Erreur lors du chargement initial." });
          } finally {
            setLoadingData(false);
          }
        };
        fetchInitialData();
      }
      else if(role_univ){
        const fetchInitialData = async () => {
          try {
            const [anneeData] = await Promise.all([
              annService.getAnneesAcademiques()
            ]);
            setAnnees(anneeData);
            setFormData({ ...formData, idUniversite: codeIesr });
          } catch (err) {
            setStatus({ type: "error", message: "Erreur lors du chargement initial." });
          } finally {
            setLoadingData(false);
          }
        };
        fetchInitialData();
      }
      else;
      }, []);
    
      useEffect(() => {
        if (!formData.idUniversite) return;
        setEtablissements([]);
        setDepartements([]);
        setParcours([]);
        setNiveaux([]);
        setFormData((prev) => ({
          ...prev,
          idEtablissement: null,
          idDepartement: null,
          idParcours: null,
          idNiveau: null,
        }));
    
        const fetchEtablissements = async () => {
          const data = await etabService.getEtablissementsByUniversite(formData.idUniversite);
          setEtablissements(data);
        };
        fetchEtablissements();
      }, [formData.idUniversite]);
    
      useEffect(() => {
        if (!formData.idEtablissement) return;
        setDepartements([]);
        setParcours([]);
        setNiveaux([]);
        setFormData((prev) => ({
          ...prev,
          idDepartement: null,
          idParcours: null,
          idNiveau: null,
        }));
    
        const fetchDepartements = async () => {
          const data = await deptService.getDepartementsByEtablissement(formData.idEtablissement);
          setDepartements(data);
        };
        fetchDepartements();
      }, [formData.idEtablissement]);
    
      useEffect(() => {
        if (!formData.idDepartement) return;
        setParcours([]);
        setNiveaux([]);
        setFormData((prev) => ({
          ...prev,
          idParcours: null,
          idNiveau: null,
        }));
    
        
        const fetchParcours = async () => {
          const data = await parsService.getParcoursByDepartement(formData.idDepartement);
          setParcours(data);
        };
        fetchParcours();
      }, [formData.idDepartement]);
    
      useEffect(() => {
        if (!formData.idParcours) return;
        setNiveaux([]);
        setFormData((prev) => ({ ...prev, idNiveau: null }));
    
        const fetchNiveaux = async () => {
          const data = await nivService.getNiveauxByParcours(formData.idParcours);
          setNiveaux(data);
        };
        fetchNiveaux();
      }, [formData.idParcours]);

      const AfficherRetraits = () => {
        setLoading(true)
        retraitService.listeRetrait(formData.idDepartement, formData.idParcours, formData.idNiveau, formData.idAnneeAcademique).then(data => {
          console.log(data)
          setRetraits(data)
        })
        .catch(error => {
          console.log(error)
        })
        .finally(fin => {
          setLoading(false)
        })
      }
  return (
    <div className="flex justify-content-center mt-5">
          <Card style={{ width: "1050px", textAlign: "center" }}>
            <div className="grid p-fluid text-left">
              {role_admin?
              <div className="grid p-fluid text-left">
                        <div className="col-6 mb-3">
                          <Dropdown
                            value={formData.idUniversite}
                            options={universites}
                            optionLabel="nomUniversite"
                            optionValue="idUniv"
                            onChange={(e) => setFormData({ ...formData, idUniversite: e.value })}
                            placeholder="Université"
                            filter
                          />
                        </div>
              
                        <div className="col-6 mb-3">
                          <Dropdown
                            value={formData.idEtablissement}
                            options={etablissements}
                            optionLabel="nom"
                            optionValue="idEtablissement"
                            onChange={(e) => setFormData({ ...formData, idEtablissement: e.value })}
                            placeholder="Établissement"
                            disabled={!formData.idUniversite}
                          />
                        </div>
              
                        <div className="col-6 mb-3">
                          <Dropdown
                            value={formData.idDepartement}
                            options={departements}
                            optionLabel="lbDepartementEtab"
                            optionValue="idDepartement"
                            onChange={(e) => setFormData({ ...formData, idDepartement: e.value })}
                            placeholder="Département"
                            disabled={!formData.idEtablissement}
                          />
                        </div>
              
                        <div className="col-6 mb-3">
                          <Dropdown
                            value={formData.idParcours}
                            options={parcours}
                            optionLabel="libelleParcours"
                            optionValue="idParcours"
                            onChange={(e) => setFormData({ ...formData, idParcours: e.value })}
                            placeholder="Parcours"
                            disabled={!formData.idDepartement}
                          />
                        </div>
              
                        <div className="col-6 mb-3">
                          <Dropdown
                            value={formData.idNiveau}
                            options={niveaux}
                            optionLabel="libelleNiveau"
                            optionValue="idNiveau"
                            onChange={(e) => setFormData({ ...formData, idNiveau: e.value })}
                            placeholder="Niveau"
                            disabled={!formData.idParcours}
                          />
                        </div>
              
                        <div className="col-6 mb-3">
                          <Dropdown
                            value={formData.idAnneeAcademique}
                            options={annees}
                            optionLabel="libelleAnnee"
                            optionValue="idAnnee"
                            onChange={(e) => setFormData({ ...formData, idAnneeAcademique: e.value })}
                            placeholder="Année académique"
                            filter
                          />
                        </div>
                        <div className="col-9 mb-3"></div>
                        <div className="col-3 mb-3">
                            <Button
                              style={{ textAlign: 'right' }}
                              icon="pi pi-check"
                              label="Afficher"
                              className="p-button-sm p-button-outlined mb-4"
                              onClick={AfficherRetraits}
                            />
                        </div>
              
                      </div>
                    :

                    <div className="grid p-fluid text-left">
                        <div className="col-6 mb-3">
                          <Dropdown
                            value={formData.idEtablissement}
                            options={etablissements}
                            optionLabel="nom"
                            optionValue="idEtablissement"
                            onChange={(e) => setFormData({ ...formData, idEtablissement: e.value })}
                            placeholder="Établissement"
                            disabled={!formData.idUniversite}
                          />
                        </div>
              
                        <div className="col-6 mb-3">
                          <Dropdown
                            value={formData.idDepartement}
                            options={departements}
                            optionLabel="lbDepartementEtab"
                            optionValue="idDepartement"
                            onChange={(e) => setFormData({ ...formData, idDepartement: e.value })}
                            placeholder="Département"
                            disabled={!formData.idEtablissement}
                          />
                        </div>
              
                        <div className="col-6 mb-3">
                          <Dropdown
                            value={formData.idParcours}
                            options={parcours}
                            optionLabel="libelleParcours"
                            optionValue="idParcours"
                            onChange={(e) => setFormData({ ...formData, idParcours: e.value })}
                            placeholder="Parcours"
                            disabled={!formData.idDepartement}
                          />
                        </div>
              
                        <div className="col-6 mb-3">
                          <Dropdown
                            value={formData.idNiveau}
                            options={niveaux}
                            optionLabel="libelleNiveau"
                            optionValue="idNiveau"
                            onChange={(e) => setFormData({ ...formData, idNiveau: e.value })}
                            placeholder="Niveau"
                            disabled={!formData.idParcours}
                          />
                        </div>
              
                        <div className="col-6 mb-3">
                          <Dropdown
                            value={formData.idAnneeAcademique}
                            options={annees}
                            optionLabel="libelleAnnee"
                            optionValue="idAnnee"
                            onChange={(e) => setFormData({ ...formData, idAnneeAcademique: e.value })}
                            placeholder="Année académique"
                            filter
                          />
                        </div>
                        <div className="col-3 mb-3">
                            <Button
                              style={{ textAlign: 'right' }}
                              icon="pi pi-check"
                              label="Afficher"
                              className="p-button-sm p-button-outlined mb-4"
                              onClick={AfficherRetraits}
                            />
                        </div>
              
                      </div>
                    } 


              <div className="col-12 mb-3">
                <DataTable value={retraits} responsive header="Liste des retraits" rows={10} paginator emptyMessage="Pas de données à afficher !">
                  <Column field="nom" header="Nom" />
                  <Column field="prenom" header="Prénom" />
                  <Column field="numCnib" header="Num. CNIB ou Passeport" />
                  <Column field="dateRetrait" header="Date retrait" />
                  {/*<Column field="fgProcuration" header="Procuration" />*/}
                  {/*<Column field="retrait" header="Retrait" />
                  <Column field="dateRetrait" header="Date rétrait" />
                  <Column header="Actions" body={"actionBodyTemplate"} style={{ textAlign: "center", width: "8em" }} />*/}
                </DataTable>
              </div>
            </div>
          </Card>
        </div>
  )
}

export default ListeRetrait